// Auth-service endpoint paths (relative to VITE_AUTH_API_URL). Referenced via
// this constant so a path change is a single edit — never hard-coded at call
// sites. Two sign-in surfaces live here: the UAE Pass hand-off (request an
// authorize URL, exchange the returned code, complete sign-up for a new seller)
// and the email one-time-code flow (request a code, verify it, resend it).
export const authEndpointPaths = {
  EMAIL_LOGIN: '/api/auth/login',
  VERIFY_OTP: '/api/auth/verify-otp',
  RESEND_OTP: '/api/auth/resend-otp',
  UAE_PASS_AUTHORIZE_URL: '/api/auth/uae-pass/authorize-url',
  UAE_PASS_CALLBACK: '/api/auth/uae-pass/callback',
  UAE_PASS_LOGOUT_URL: '/api/auth/uae-pass/logout-url',
  UAE_PASS_REGISTER: '/api/auth/uae-pass/register',
  LOGOUT: '/api/auth/logout',
} as const
